var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoneNotHeardRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 60.9821C17.9902 62.0866 18.8776 62.99 19.9821 62.9999L37.9814 63.1609C39.0859 63.1708 39.9893 62.2834 39.9992 61.1788C40.0091 60.0743 39.1217 59.1709 38.0172 59.161L22.0178 59.018L22.1609 43.0186C22.1708 41.9141 21.2834 41.0107 20.1788 41.0008C19.0743 40.9909 18.1709 41.8783 18.161 42.9828L18.0001 60.9821ZM44.4331 37L43.0316 35.5732L18.5985 59.5732L20 61L21.4015 62.4268L45.8346 38.4268L44.4331 37Z",
    fill: "#A13636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4331 17L39.4331 34.5L59.4331 52",
    stroke: "#A13636",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoneNotHeardRight);
export default __webpack_public_path__ + "static/media/BoneNotHeardRight.545d2b81248ffb204af6cce8a0daa679.svg";
export { ForwardRef as ReactComponent };